// extracted by mini-css-extract-plugin
export default {"label":"QueryName_label__gqp3K","labelReadOnly":"QueryName_labelReadOnly__UFq0O","input":"QueryName_input__W3Ajz"};